"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Index {
    constructor(parent, registrantId = null) {
        this.parent = parent;
        this.rc = parent.rc;
        this.registrantId = registrantId;
    }
    path(withParameter = true) {
        if (withParameter && this.registrantId !== null) {
            return `${this.parent.path()}/registrants/${this.registrantId}`;
        }
        return `${this.parent.path()}/registrants`;
    }
    /**
     * Returns the list of Registrants ordered by "id" ascending.
   *
   * A caller must be an authorized user: either a host of the webinar or an IT Admin:
   * a user from host's account with "WebinarSettings" permission.
   *
     * HTTP Method: get
     * Endpoint: /webinar/registration/v1/sessions/{sessionId}/registrants
     * Rate Limit Group: Heavy
     * App Permission: ReadWebinars
     */
    async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Creates a new Registrant for a given session.
   *
   * Registration MUST be open for the session for this call to succeed (otherwise it should return HTTP 403).
   *
   * A caller must be an authorized user: either a host of the webinar or an IT Admin:
   * a user from host's account with "WebinarSettings" permission.
   *
     * HTTP Method: post
     * Endpoint: /webinar/registration/v1/sessions/{sessionId}/registrants
     * Rate Limit Group: Heavy
     * App Permission: EditWebinars
     */
    async post(registrantBaseModel, restRequestConfig) {
        const r = await this.rc.post(this.path(false), registrantBaseModel, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Returns a Registrant by ID.
   *
   * A caller must be an authorized user: either a host of the webinar or an IT Admin:
   * a user from host's account with "WebinarSettings" permission.
   *
     * HTTP Method: get
     * Endpoint: /webinar/registration/v1/sessions/{sessionId}/registrants/{registrantId}
     * Rate Limit Group: Heavy
     * App Permission: ReadWebinars
     */
    async get(queryParams, restRequestConfig) {
        if (this.registrantId === null) {
            throw new Error('registrantId must be specified.');
        }
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Deletes a Registrant by ID.
   *
   * Session must not be in finished state (otherwise it should return HTTP 403).
   *
   * A caller must be an authorized user: either a host of the webinar or an IT Admin:
   * a user from host's account with "WebinarSettings" permission.
   *
     * HTTP Method: delete
     * Endpoint: /webinar/registration/v1/sessions/{sessionId}/registrants/{registrantId}
     * Rate Limit Group: Heavy
     * App Permission: EditWebinars
     */
    async delete(restRequestConfig) {
        if (this.registrantId === null) {
            throw new Error('registrantId must be specified.');
        }
        const r = await this.rc.delete(this.path(), undefined, restRequestConfig);
        return r.data;
    }
}
exports.default = Index;
//# sourceMappingURL=index.js.map